import React, { useState } from 'react'
import { Container, Row, Col, Nav } from 'react-bootstrap'
import './HallwayContent.scss'
import ReactHtmlParser from 'react-html-parser'
import { preventContextMenu } from '../../Utils'
import LRSPath from '../LRSPath'

import { Section, Lesson, SceneRoom } from '../../Types'
import * as LearningLab from './LearningLab'
import { isDebug } from '../../App.config'
import { useLearningLab, LearningLabActionType } from '../../contexts/LearningLabContext'

type Props = {
    navigateToRoom: (room: SceneRoom) => void
}

const HallwayContent: React.FC<Props> = ({ navigateToRoom }: Props) => {
    const { state, dispatch } = useLearningLab()
    const [showLessons, setShowLessons] = useState(true)

    const handleLessonClick = (event: React.MouseEvent, lessonID: number) => {
        event && event.preventDefault()
        isDebug && console.log('Clicked on lesson', lessonID)
        setShowLessons(false)
        dispatch({ type: LearningLabActionType.SET_CURRENT_LESSON_ID, payload: lessonID })
        navigateToRoom(SceneRoom.Lab)
    }

    if (!showLessons || state.currentSectionId === 0) return <></>

    const section: Section = LearningLab.section(state.currentSectionId)
    const sectionDesc = ReactHtmlParser(section.description)
    const lessonList = section.lessons.map((lesson: Lesson) => {
        return (
            <LRSPath
                key={'l' + lesson.id}
                label={lesson.name}
                path={''}
                sectionID={section.id}
                lessonID={lesson.id}
                clickHandler={handleLessonClick}
            />
        )
    })

    return (
        <div className="overlay top click-through">
            <Container
                onContextMenu={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => preventContextMenu(e)}
                className="min-specs module-content hallway"
                fluid={true}
            >
                <Row>
                    <Col sm={{ offset: 3 }}>
                        <div className="title">
                            {section.name}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={{ offset: 3, span: 4 }}>
                        <section className="description">
                            {sectionDesc}
                        </section>
                    </Col>
                    <Col sm={{ span: 5 }}>

                        <Nav className="justify-content-end flex-column lesson-list interactive">
                            {lessonList}
                        </Nav>

                    </Col>
                </Row>
            </Container>
        </div>
    )

}
export default HallwayContent